import { useState } from "react";

import { useQuery, useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

import { NotificationToast } from "../../../../../../../../../../components/Generic/Toast/NotificationToast";
import { useAppState } from "../../../../../../../../../../context/StateContext";
import { Company } from "../../../../../../../../../../models/company";
import CompanyService from "../../../../../../../../../../services/company.service";
import { checkError } from "../../../../../../../../../../util/checkError";
import useActionSyncUser from "../../../../../../../../../../hooks/useSyncUser";

const useActions = () => {
  const { currentUser } = useAppState();
  const { t: translate } = useTranslation();
  const { mutate: syncUser } = useActionSyncUser();

  const [company, setCompany] = useState<Company>();

  const { refetch, isFetching } = useQuery(
    ["company.getById"],
    () => CompanyService.getById(currentUser?.companyId || 0),
    {
      enabled: !!currentUser?.companyId,
      refetchOnWindowFocus: false,
      onSuccess: (response) => {
        if (response && response.data) {
          setCompany(response.data);
        }
      },
    }
  );

  const { mutate, isLoading: isUpdating } = useMutation(
    ["company.update"],
    ({ id, company }: { id: number; company: Company }) => CompanyService.update(id, company),
    {
      onSuccess: () => {
        NotificationToast.success(translate("operationPerformedSuccessfully"), {
          id: "request.notification.update.company",
        });
        refetch();
        syncUser();
      },
      onError: (error: AxiosError<Error>) => {
        checkError(error, translate("anErrorOccurredTryAgain"));
      },
    }
  );

  return {
    mutate,
    company,
    isLoading: isFetching,
    isUpdating,
  };
};

export default useActions;
